/**
 * What an audit row says about how its change ended, for the Audit Trail screen.
 *
 * Rows for changes to who may do what (`admin › user access`, role definitions) are written
 * *before* the change and closed afterwards, so a row carries a `status` as well as the
 * HTTP `status_code` the middleware writes for everything else. Only `applied` means the
 * change landed. A row still `requested` never recorded its outcome, and `unknown` is one
 * whose write raised something that does not say whether it landed; showing either as an
 * ordinary row is how an unfinished change reads as a finished one.
 */

const LABELS = {
  requested: "outcome not recorded",
  failed: "failed",
  unknown: "outcome unknown",
  revoked_not_reissued: "revoked, not re-issued",
};

/**
 * The text of the badge a row needs, or null when it needs none.
 *
 * @param {{status?: string, status_code?: number}} log an audit row.
 * @returns {string|null}
 */
export function auditStatusBadge(log) {
  const label = LABELS[log?.status];
  if (label) return log.status_code >= 400 ? `${label} · HTTP ${log.status_code}` : label;
  if (log?.status_code >= 400) return `failed · HTTP ${log.status_code}`;
  return null;
}
